import React from "react";
import {
    List,
    Datagrid,
    TextField,
    useRecordContext,
    TextInput,
    DateInput,
    useListContext,
    Button,
    useGetList,
    DateField,
} from "react-admin";
import { Link } from "react-router-dom";
import LargePagination from "../core/LargePagination";

const textFieldStyle = {
    fontSize: 13,
};

const SELECTED_BUTTON_COLOR = "#b4d4fa";

const SiteField = (props) => {
    const record = useRecordContext();

    return props.linkToSite ? (
        <Link label={props.label} to={"https://portal.linevisioninc.com/site/" + record.id}>
            <TextField style={textFieldStyle} source={props.source} />
        </Link>
    ) : (
        <TextField style={textFieldStyle} label={props.label} source={props.source} />
    );
};

const ModelFilterButtons = (props) => {
    const { filterValues, setFilters } = useListContext();

    const modelTypes = ["LIDAR_DLR", "LIDAR_ICING", "LIDAR_GEOMETRY", "UNMONITORED_WDLR"];

    if (!props.isLoaded.current) {
        // Do not display UNMONITORED_WDLR records on initial load
        const index = modelTypes.indexOf("UNMONITORED_WDLR");
        modelTypes.splice(index, 1);
        setFilters({ model_type: modelTypes });
        props.isLoaded.current = true;
    }

    const buttonStyles = {};
    if (filterValues.model_type && filterValues.model_type.length !== 0) {
        modelTypes.forEach((t) =>
            filterValues.model_type.includes(t)
                ? (buttonStyles[t] = { backgroundColor: SELECTED_BUTTON_COLOR })
                : (buttonStyles[t] = {})
        );
    } else {
        modelTypes.forEach((t) => (buttonStyles[t] = { backgroundColor: SELECTED_BUTTON_COLOR }));
    }

    const filterButtons = [];
    const filters = filterValues.model_type ? filterValues.model_type : [];

    modelTypes.forEach((t) =>
        filterButtons.push(
            <Button
                onClick={() => {
                    if (filters.includes(t)) {
                        const index = filters.indexOf(t);
                        filters.splice(index, 1);
                    } else {
                        filters.push(t);
                    }
                    setFilters({ ...filterValues, model_type: filters });
                }}
                label={t}
                style={buttonStyles[t]}
                key={t}
            />
        )
    );

    return <div style={{ justifyContent: "center", alignItems: "center" }}>{filterButtons}</div>;
};

export const SiteGroupCheatSheetList = (props) => {
    const isLoaded = React.useRef(false);

    const filters = [
        <TextInput key="id" style={{ width: 120 }} label="Site Group ID" source="id" alwaysOn />,
        <TextInput key="lidar_ed_id" style={{ width: 120 }} label="Edge Device ID" source="lidar_ed_id" alwaysOn />,
        <TextInput key="short_name" label="Site Group Short Name" source="short_name" alwaysOn />,
        <TextInput key="client_id" style={{ width: 120 }} label="Client ID" source="client_id" alwaysOn />,
        <DateInput key="online_date" label="Online Date After" source="online_date" alwaysOn />,
        <ModelFilterButtons key="model_filter" isLoaded={isLoaded} alwaysOn />,
    ];

    return (
        <List
            title="Site Group Cheat Sheet"
            perPage={500}
            pagination={<LargePagination />}
            filters={filters}
            {...props}
        >
            <Datagrid bulkActionButtons={false}>
                <SiteField label="Site Group ID" source="id" linkToSite />
                <SiteField label="Short Name" source="short_name" />
                <SiteField label="Lidar ED ID" source="lidar_ed_id" />
                <DateField
                    label="Online Date UTC"
                    source="online_date"
                    options={{
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                        hour: "2-digit",
                        minute: "2-digit",
                        timeZone: "UTC",
                    }}
                    locales="sv-SE" // using the swedish locale here to get date into YYYY-MM-DD and 24 hour format easily
                />
                <SiteField label="Cond IDs" source="cond_ids" />
                <SiteField label="Line ID" source="line_id" />
                <SiteField label="Client ID" source="client_id" />
                <SiteField label="Model Type" source="model_type" />
            </Datagrid>
        </List>
    );
};
